export const engagementEmailTemplatesTags = "/engagement/email_templates/tags";
